import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';

export function useAddQueryToUrl() {
  const getLinkWithQuery = (queryParams: Record<string, string | null>, newPathname?: string) => {
    const url = new URL(window.location.href);
    Object.keys(queryParams).forEach((key: string) => {
      const value = queryParams[key];
      if (value) {
        url.searchParams.set(key, value);
      }
      else {
        url.searchParams.delete(key);
      }
    });
    const pathName = newPathname ?? url.pathname;
    const routePath = pathName + url.search;
    return getParameterizedLink(routePath);
  };
  const getValue = (key: string) => {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  };

  return {
    getLinkWithQuery,
    getValue
  };

}